import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "googleMapsLatLngLit",
})
export class GoogleMapsLatLngLitPipe implements PipeTransform {
  transform(
    lat: unknown,
    lng: unknown,
    defaultLatLngLit: google.maps.LatLngLiteral,
  ): google.maps.LatLngLiteral;
  transform(
    location: unknown,
    defaultLatLngLit: google.maps.LatLngLiteral,
  ): google.maps.LatLngLiteral;
  transform(
    lat: unknown,
    lng?: unknown,
    defaultLatLngLit?: google.maps.LatLngLiteral,
  ): google.maps.LatLngLiteral {
    if (typeof lat === "number" && typeof lng === "number") {
      return {
        lat,
        lng,
      };
    }
    if (typeof lat === "object" && lat != null) {
      if (lat instanceof google.maps.LatLng) {
        return lat.toJSON();
      }
      if (
        "lat" in lat &&
        typeof lat.lat === "number" &&
        "lng" in lat &&
        typeof lat.lng === "number"
      ) {
        return {
          lat: lat.lat,
          lng: lat.lng,
        };
      }
      if (
        "latitude" in lat &&
        typeof lat.latitude === "number" &&
        "longitude" in lat &&
        typeof lat.longitude === "number"
      ) {
        return {
          lat: lat.latitude,
          lng: lat.longitude,
        };
      }
    }
    if (
      typeof lng === "object" &&
      lng != null &&
      "lat" in lng &&
      typeof lng.lat === "number" &&
      "lng" in lng &&
      typeof lng.lng === "number"
    ) {
      return {
        lat: lng.lat,
        lng: lng.lng,
      };
    }
    return defaultLatLngLit!;
  }
}
